import { ref } from 'vue'
import api from '../api'
import { ArquivoRepository } from './arquivo-repository'
import { StatusArquivo } from './status-arquivo'
import type { Arquivo } from './arquivo'
import { sleep } from '@/lib/beep'

export * from './arquivo'
export * from './arquivo-repository'
export * from './tipo-arquivo'
export * from './status-arquivo'

export const arquivo_repository = new ArquivoRepository(api)
export const processando = ref<Map<string, Arquivo>>(new Map())

export const loadArquivosProcessando = async () => {
    try {
        let rows = await arquivo_repository.search({
            status: StatusArquivo.PROCESSANDO
        });        

        let result: Map<string, Arquivo> = new Map()
        for(let row of rows) {
            result.set(row.id, row)
        }
        processando.value = result
    } catch (error) {
        console.error(error)
    }
    await sleep(5000)
    loadArquivosProcessando()
}

loadArquivosProcessando()
arquivo_repository.processar()